import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {

  public loginData = {username: '', password: ''};

  constructor(private authService: AuthService) { }

  ngOnInit() {
  }

  login() {
    // this._service.obtainAccessToken(this.loginData);
    this.authService.login(this.loginData);
  }

}
// export class LoginComponent {
//   public loginData = {username: "", password: ""};
//
//   constructor(private _service:AppService) {}
//
//   login() {
//     this._service.obtainAccessToken(this.loginData);
//   }
// }
